"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
/**
 *
 * @component TruncateTooltip
 * @param children accepts any children that Typography accepts. Minimally, you can pass a string.
 *
 * @example
 * <TruncateTooltip children='testing' />
 */
var TruncateTooltip = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var ref = (0, react_2.useRef)(null);
    var _b = (0, react_2.useState)(false), tooltipEnabled = _b[0], setTooltipEnabled = _b[1];
    (0, react_2.useEffect)(function () {
        var compareSize = function () {
            if (ref.current) {
                var compare = ref.current.scrollWidth > ref.current.clientWidth;
                setTooltipEnabled(compare);
            }
        };
        compareSize();
        window.addEventListener("resize", compareSize);
        return function () { return window.removeEventListener("resize", compareSize); };
    }, []);
    return (react_1.default.createElement(material_1.Tooltip, { title: children, disableHoverListener: !tooltipEnabled },
        react_1.default.createElement(material_1.Typography, __assign({ ref: ref, noWrap: true, overflow: "hidden", textOverflow: "ellipsis" }, props), children)));
};
exports.default = TruncateTooltip;
